import { MDCDrawer } from '@material/drawer'

const bindMenus = (element: Element) => {
  const customStickersMenu = element.querySelector('.custom-stickers-menu')
  const dropdownButton = element.querySelector('.menu-drop-down-icon')

  // dropdownButton.addEventListener('click', () => {
  //   customStickersMenu.classList.toggle('si-hidden')
  // })
  const openCustomStickersEls = element.querySelectorAll(
    '.si-menu-action-open-custom-stickers'
  )
  openCustomStickersEls.forEach((el) => {
    el.addEventListener('click', () => {
      customStickersMenu.classList.toggle('si-hidden')
      dropdownButton.innerHTML = customStickersMenu.classList.contains(
        'si-hidden'
      )
        ? 'arrow_drop_down'
        : 'arrow_drop_up'
    })
  })
}

export default (element: Element) => {
  const topAppBarElement = element.querySelector('.mdc-top-app-bar')
  const menuButton = topAppBarElement.querySelector('.si-action-open-menu')

  const drawerEl: HTMLDivElement = element.querySelector('.mdc-drawer')
  const drawer = MDCDrawer.attachTo(drawerEl)

  const menuButtonClick = () => {
    drawer.open = !drawer.open
    if (drawer.open) {
      drawerEl.style.top = '0px'
      drawerEl.style.width = '85%'
    }
  }

  menuButton.addEventListener('click', menuButtonClick)

  bindMenus(element)
}
